import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Link } from 'react-router'

import { Button } from '@/components/elements/button'
import { Card, CardContent } from '@/components/elements/card'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/elements/form'
import { Input } from '@/components/elements/input'
import { forgotPassword } from '@/services/user.service'
import { toast } from '@/utils/helpers'

const PasswordResetRequest = () => {
  // State
  const [loading, setLoading] = useState(false)

  const handleSuccess = (m) => toast(m, 'success')
  const handleError = (m) => toast(m, 'error')

  const form = useForm({
    defaultValues: {
      email: '',
    },
  })

  /**
   * Handles form submission
   * - Clears form if successful
   * @param {object} data
   */
  const onSubmit = async (data) =>
    forgotPassword(data, handleError, setLoading, (m) => {
      handleSuccess(m)

      // Reset form
      form.reset({ email: '' })
    })

  return (
    <div className="bg-muted flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-lg">
        <div className="flex flex-col gap-6">
          <Card className="overflow-hidden p-0">
            <CardContent className="p-0">
              <Form {...form}>
                <form className="p-6 md:p-8" onSubmit={form.handleSubmit(onSubmit)}>
                  <div className="flex flex-col gap-6">
                    <div className="flex flex-col items-center text-center">
                      <h1>Forgot your password?</h1>
                      <p className="text-muted-foreground mt-2 text-center text-sm text-balance">
                        Or{' '}
                        <Link
                          to="/login"
                          className="text-primary ml-auto underline-offset-2 hover:underline"
                        >
                          Log In
                        </Link>
                      </p>
                    </div>

                    <FormField
                      control={form.control}
                      disabled={loading}
                      name="email"
                      render={({ field }) => (
                        <FormItem>
                          <FormLabel>Email</FormLabel>
                          <FormControl>
                            <Input
                              data-testid="email"
                              id="email"
                              type="email"
                              placeholder="m@example.com"
                              {...field}
                            />
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                      rules={{ required: true }}
                    />

                    <Button loading={loading} type="submit" className="w-full">
                      Submit
                    </Button>
                  </div>
                </form>
              </Form>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default PasswordResetRequest
